import $ from 'jquery';
import { accountRegister } from "../queries";
import Popup from "../utilities/Popup";
import {Cookie} from '../utilities'

let captchaIsValid = false;

window.captchaSuccessCallback = (e) => {
    captchaIsValid = true;
};

window.captchaExpiredCallback = (e) => {
    captchaIsValid = false;
};

if ($('.js-form-register')){
    const formCookies = Cookie.get('REF_REGISTER_FORM');
    const jsonFormValues = JSON.parse(formCookies);
    // if (formCookies){
    //     for(let key in jsonFormValues) {
    //         $(`[name=${key}]`).val(jsonFormValues[key]).focus()
    //     }
    // }
}
$(document).ready(function() {
    $("[name=last_name],[name=first_name],[name=second_name]").on("input", function() {
        let value = $(this).val();
        value = value.replace(/[^а-яА-Яa-zA-Z\s-]/g, '');
        value = value.charAt(0).toUpperCase() + value.slice(1);
        $(this).val(value);
    });
    $("[name=partner_id]").on("input", function() {
        let value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        if (value.length > 10) {
            value = value.slice(0, 10); // Обрезаем до 10 символов
        }
        $(this).val(value);
    });
});
$('.js-form-register').on('submit', async function (e) {
    e.preventDefault(); // Предотвращаем отправку формы по умолчанию

    var form = $(this);
    var errorField = null;

    form.find('.has-error').removeClass('has-error');
    $('.after-element').remove();
    form.find('.ui-form__error').hide().text('');
    form.find('.ui-input__error-message').remove(); // Удаляем существующие сообщения об ошибке
    form.find('.ui-button').prop('disabled', true); // Блокируем кнопку отправки формы

    form.find('.ui-input__control').each(function () {
        var input = $(this);
        var value = input.val().trim();
        var type = input.attr('type');
        var name = input.attr('name');
        if ((type === 'text' && $(this).attr('name') !== 'partner_id') && $(this).attr('name') !== 'second_name' && $(this).attr('name') !== 'fake_partner_id' || type === 'password') {
            if (value === '') {
                input.addClass('has-error');
                errorField = errorField || input;
                // input.after('<div class="ui-input__error-message">Поле не должно быть пустым</div>');
            }
        }
        if (type === 'email') {
            var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (value === '' || !emailRegex.test(value)) {
                input.addClass('has-error');
                errorField = errorField || input;
                input.after('<div class="ui-input__error-message">Введите корректный email</div>');
            }
        }
        if (name === 'phone') {
            var phoneRegex = /^\+7 \(\d{3}\)-\d{3}-\d{2}-\d{2}$/;
            if (value === '' || !phoneRegex.test(value)) {
                input.addClass('has-error');
                errorField = errorField || input;
                input.after('<div class="ui-input__error-message">Введите корректный номер телефона</div>');
                if ($('.after-element').length === 0) {
                    input.siblings().filter('.ui-input__label').append('<span class="after-element">*</span>');
                    $('.after-element').css({'color': '#e30621', 'margin-left': '4px' });
                }
            }
        }
        if (name === 'partner_id') {
            if (value !== '' && value.length > 10) {
                input.addClass('has-error');
                errorField = errorField || input;
                input.after('<div class="ui-input__error-message">Промокод должен содержать не более 10 цифр</div>');
            }
        }
    });

    if (errorField) {
        var errorLabel = form.find('.ui-form__error');
        var errorMessage = 'Пожалуйста, заполните поле правильно.';
        errorLabel.text(errorMessage).show();

        $('html, body').animate({
            scrollTop: errorField.offset().top - 100
        }, 300);

        form.find('.ui-button').prop('disabled', false); // Разблокируем кнопку отправки формы
        $(this).trigger('error', 'Заполните обязательные поля');
        return;
    }


    // form.off('submit').on('ui-submit', async function(e) {
    //     e.preventDefault(); // Предотвращаем отправку формы

    // Здесь можно добавить код для валидации captcha
    // if (!captchaIsValid) {
    //     $(this).trigger('error', 'Вы должны потдтвердить, что вы не робот');
    //     return;
    // }

    let registerData = $(this).serializeJSON();

    registerData.first_name = registerData.first_name.replace(/\d+/g, "");
    registerData.last_name = registerData.last_name.replace(/\d+/g, "");
    registerData.second_name = registerData.second_name.replace(/\d+/g, "");
    const response = await accountRegister(registerData);
    const loginForm = document.querySelector("#loginForm");
    const registerForm = document.querySelector("#registerForm");
    const smsForm = document.querySelector("#smsForm");
    document.querySelector("#hashContent").value = response.hashContent

    console.log(response.hashContent);

    if (!response.isSuccess && response.error) {
        if (response.error === 'Сервер не доступен, попробуйте позже') {
            Popup.showContent('Ошибка', 'Сервер не доступен, попробуйте позже', 700, true);
            let savedFormElements = registerData;
            // Object.keys(savedFormElements).map((item) => {
            //     if(item !== "name" && item !== "email" && item !== "phone"){
            //         delete savedFormElements[item];
            //     }
            // });
            Cookie.set('REF_REGISTER_FORM', JSON.stringify(savedFormElements));
        }
        $(this).trigger('error', response.error);
        form.find('.ui-button').prop('disabled', false); // Разблокируем кнопку отправки формы
        return;
    }
    if (response.isSuccess && registerData.reg_name == "order") {
        loginForm.style.display = "none";
        registerForm.style.display = "none";
        smsForm.style.display = "block";
    }

    if (response.isRedirect) {
        window.ym(56412904, 'reachGoal', 'user-login');
        window.ym(56412904, 'reachGoal', 'user-register')
        setTimeout(() => {
             location.href = response.url;
        }, 300);
        return;
    }
    // $(this).trigger('error', 'Ошибка регистрации. Пожалуйста, попробуйте позже.');
    // });

    // form.trigger('ui-submit'); // Вызываем событие ui-submit для проверки и отправки формы
});

// Обработчик события input для поля электронной почты
$('.js-form-register input[name="email"]').on('input', function() {
    var input = $(this);
    var value = input.val().trim();
    var notifyMessage = $('.ui-input__notify-message');

    if (value !== '') {
        $('.js-form-register').find('.ui-input__error-message').remove(); // Удаляем существующие сообщения об ошибке
        if (!isValidEmail(value)) {
            input.addClass('has-error');
            input.after('<div class="ui-input__error-message">Введите корректный email</div>');
        } else {
            input.removeClass('has-error');
            if (notifyMessage.length === 0) {
                var notifyElement = $('<div class="ui-input__notify-message">Почта необходима для обработки заказа в Службе Доставки</div>');
                input.after(notifyElement);
                notifyElement.hide().fadeIn(200);
            }
        }
    } else {
        notifyMessage.fadeOut(200, function() {
            $(this).remove();
        }); // Удаляем существующее сообщение с уведомлением
        input.removeClass('has-error');
    }
});

// Вспомогательная функция для проверки корректности email
function isValidEmail(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

$('.js-page-register-promote').click(function () {
    $('[name="news_subscribe"]').prop('checked', true).trigger('change');
    $('.page-register-promo').hide();
    $('.ui-modal').trigger('hide');
});

$('[name="news_subscribe"]').change(function () {
    if ($(this).is(':checked')) {
        $(".ui-form-section--partner").show();
        $('.page-register-promo').fadeOut(300).hide();
        $('.ui-form-section--warehouse').show().find('select').prop('required', true);
    } else {
        $(".ui-form-section--partner").hide();
        $(".page-register-promo").fadeIn().show();
        $('.ui-form-section--warehouse').hide().find('select').prop('required', false);
    }
});
$('[name="register_type"]').change(function () {
    if ($(this).val() === 'client') {
        $('.page-register-promo, .ui-checkbox--news-subscribe').show();
    } else {
        $('.page-register-promo, .ui-checkbox--news-subscribe').hide();
        $('[name="news_subscribe"]').prop('checked', true).trigger('change');
    }
});
